import { render } from "./StickyAddToBag.vue?vue&type=template&id=587b4386&scoped=true"
import script from "./StickyAddToBag.vue?vue&type=script&lang=js"
export * from "./StickyAddToBag.vue?vue&type=script&lang=js"

import "./StickyAddToBag.vue?vue&type=style&index=0&id=587b4386&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587b4386"]])

export default __exports__